import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'labelize'
})
export class LabelizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value.replace('_', ' ');
    } else {
      return 'UNKNOWN';
    }
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/labelize.pipe.ts